import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=ddb055b6&scoped=true&"
import script from "./NotAuthorized.vue?vue&type=script&lang=js&"
export * from "./NotAuthorized.vue?vue&type=script&lang=js&"
import style0 from "./NotAuthorized.vue?vue&type=style&index=0&id=ddb055b6&prod&lang=scss&"
import style1 from "./NotAuthorized.vue?vue&type=style&index=1&id=ddb055b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb055b6",
  null
  
)

export default component.exports